import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface IMadlibFormValue {
  [ctrlName: string]: {
    graphQlKey: string;
    human: string;
  };
}

export type TValidMadlibDimension = 'focus' | 'filter' | 'grouping';

export interface IMadlibFormInfo {
  form: IMadlibFormValue;
  dim: TValidMadlibDimension;
}

@Component({
  selector: 'viz-mad-lib',
  template: require('./viz-mad-lib.component.html'),
  styles: [require('./viz-mad-lib.component.scss')],
})
export class VizMadlibComponent {
  @Input() madlibForm: FormGroup;
  @Input() madlibData: Array<{ options: any; type: string }>;
  @Output() madlibModel = new EventEmitter<any>();

  madlibHelperText: string[] = ['for', 'grouped by'];

  updateMadlibModel(dimension: TValidMadlibDimension, option: IMadlibFormValue): void {
    this.madlibModel.emit({ dimension, option });
  }
}
